import PropTypes from 'prop-types';

export const FooterItemGridPropTypes = {
  /**
   * Array of columns to be rendered in the footer grid.
   * Each column can optionally have a title and must contain an array of items.
   *
   */
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The title of the column.
       * If the title is omitted, the column will render without a title.
       *
       */
      title: PropTypes.string,
      /**
       * The array of items to be rendered under this column.
       * Each item should contain a `label` and can optionally include an `onClick` handler.
       */
      items: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The label of the item, which will be displayed as button text.
           */
          label: PropTypes.string.isRequired,
          /**
           * Optional click handler for the item.
           * If provided, it will be triggered when the button is clicked.
           */
          onclick: PropTypes.func,
        }),
      ).isRequired,
    }),
  ).isRequired,
};
